(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tbv-browse-menu"] && !Shopify.designMode) return;
  try {
    (() => {
  const root = document.querySelector('[data-tbv-browse-root]');
  if (!root) return;

  const groups = JSON.parse(root.querySelector('[data-tbv-browse-groups]').textContent);
  const items = groups.flatMap(group => group.items);
  const bySlug = new Map(items.map(item => [item.slug, item]));
  const directory = document.querySelector('[data-tbv-directory]');
  const categoryUrl = slug => `/pages/all-collections?category=${encodeURIComponent(slug)}`;
  const text = (tag, value, className) => {
    const element = document.createElement(tag);
    element.textContent = value;
    if (className) element.className = className;
    return element;
  };
  let indexPromise;

  function searchForm(className) {
    const form = document.createElement('form');
    form.className = className;
    form.action = '/search';
    form.method = 'get';
    const type = document.createElement('input');
    type.type = 'hidden';
    type.name = 'type';
    type.value = 'product';
    const query = document.createElement('input');
    query.type = 'search';
    query.name = 'q';
    query.placeholder = 'Search a name, era, or subject';
    query.setAttribute('aria-label', 'Search the Vault');
    query.required = true;
    const button = text('button', 'Search', 'tbv-browse-search__button');
    button.type = 'submit';
    form.append(type, query, button);
    return form;
  }

  function groupList(group, className) {
    const list = document.createElement('ul');
    list.className = className;
    group.items.forEach(item => {
      const li = document.createElement('li');
      const link = document.createElement('a');
      link.href = categoryUrl(item.slug);
      link.setAttribute('aria-label', `${item.name}, about ${item.count} busts`);
      link.append(text('span', item.name, 'tbv-browse-link__name'), text('span', item.count, 'tbv-browse-link__count'));
      li.append(link);
      list.append(li);
    });
    return list;
  }

  function installDesktop() {
    const link = [...document.querySelectorAll('header-menu .menu-list__link')]
      .find(candidate => candidate.getAttribute('href') === '/pages/all-collections');
    const submenu = link?.closest('.menu-list__list-item')?.querySelector('.menu-list__submenu-inner');
    if (!link || !submenu || submenu.querySelector('[data-tbv-mega]')) return;
    const title = link.querySelector('.menu-list__link-title');
    const caret = text('span', '', 'tbv-menu-caret');
    caret.setAttribute('aria-hidden', 'true');
    if (title) {
      title.textContent = 'Browse Busts';
      title.append(caret);
    }
    const panel = document.createElement('div');
    panel.className = 'tbv-mega';
    panel.dataset.tbvMega = '';
    const top = document.createElement('div');
    top.className = 'tbv-mega__top';
    const intro = document.createElement('div');
    intro.append(text('p', 'EXPLORE THE VAULT', 'tbv-mega__eyebrow'), text('p', 'Find a subject worth collecting.', 'tbv-mega__title'));
    top.append(intro, searchForm('tbv-browse-search'));
    const columns = document.createElement('div');
    columns.className = 'tbv-mega__columns';
    groups.forEach(group => {
      const column = document.createElement('section');
      column.className = 'tbv-mega__column';
      column.append(text('h2', group.heading, 'tbv-mega__heading'), groupList(group, 'tbv-mega__links'));
      columns.append(column);
    });
    const footer = document.createElement('a');
    footer.className = 'tbv-mega__footer';
    footer.href = '/collections/all';
    footer.textContent = 'Browse every bust in the Vault  →';
    panel.append(top, columns, footer);
    submenu.replaceChildren(panel);
  }

  function installMobile() {
    const link = document.querySelector('#HeaderDrawer-library');
    const row = link?.closest('li');
    if (!row) return;

    const outer = document.createElement('details');
    outer.className = 'tbv-drawer';
    const summary = text('summary', 'Browse Busts', 'tbv-drawer__title');
    outer.append(summary);

    const content = document.createElement('div');
    content.className = 'tbv-drawer__content';

    const mainView = document.createElement('div');
    mainView.className = 'tbv-drawer__main-view';
    const categoryView = document.createElement('div');
    categoryView.className = 'tbv-drawer__category-view';
    categoryView.hidden = true;

    const browseAll = text('a', 'Shop All Busts', 'tbv-drawer__shop-all');
    browseAll.href = '/collections/all';
    mainView.append(browseAll);

    const subtitles = [
      'Presidents, kings, military figures',
      'Scientists, thinkers, inventors',
      'Authors, poets, musicians',
      'Greek, Roman, Egyptian',
      'Pop culture, sports, memes'
    ];
    const names = [
      'History & Leaders',
      'Science & Philosophy',
      'Writers & Artists',
      'Ancient & Mythology',
      'Culture & Collectibles'
    ];

    function showMain() {
      categoryView.hidden = true;
      mainView.hidden = false;
      categoryView.replaceChildren();
    }

    groups.forEach((group, index) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'tbv-drawer__category-button';
      const label = document.createElement('span');
      label.className = 'tbv-drawer__category-label';
      label.append(text('strong', names[index] || group.heading), text('small', subtitles[index] || 'Explore bust collections'));
      button.append(label, text('span', '›', 'tbv-drawer__chevron'));
      button.addEventListener('click', () => {
        const back = text('button', '‹  Back to categories', 'tbv-drawer__back');
        back.type = 'button';
        back.addEventListener('click', showMain);
        const title = text('h3', names[index] || group.heading, 'tbv-drawer__category-heading');
        const links = groupList(group, 'tbv-drawer__links');
        categoryView.replaceChildren(back, title, links);
        mainView.hidden = true;
        categoryView.hidden = false;
        content.scrollTop = 0;
      });
      mainView.append(button);
    });

    content.append(mainView, categoryView);
    outer.append(content);
    outer.addEventListener('toggle', () => { if (!outer.open) showMain(); });
    row.replaceChildren(outer);
  }

  function installNavigation() {
    installDesktop();
    installMobile();
  }

  function belongs(product, item) {
    if (item.exclude.includes(product.handle)) return false;
    if (item.collection && product.collections.some(shelf => shelf.handle === item.collection)) return true;
    return item.terms.some(term => {
      const escaped = term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      return new RegExp(`(^|[^a-z])${escaped}($|[^a-z])`).test(product.handle);
    });
  }

  async function fetchPage(page) {
    const url = new URL(root.dataset.tbvBrowseIndexUrl, location.origin);
    url.searchParams.set('section_id', 'tbv-vault-index');
    url.searchParams.set('sort_by', 'best-selling');
    url.searchParams.set('page', page);
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    if (preview && /^\d+$/.test(preview)) url.searchParams.set('preview_theme_id', preview);
    const response = await fetch(url, { credentials: 'same-origin', signal: AbortSignal.timeout(20000) });
    if (!response.ok) throw new Error('Catalog unavailable');
    const html = new DOMParser().parseFromString(await response.text(), 'text/html');
    const payload = html.querySelector('[data-vault-index]');
    if (!payload) throw new Error('Catalog unavailable');
    const data = JSON.parse(payload.textContent);
    if (!Array.isArray(data.products) || !Number.isInteger(data.pages) || data.page !== page || data.pages > 100) throw new Error('Incomplete catalog');
    return data;
  }

  function loadIndex() {
    if (!indexPromise) indexPromise = (async () => {
      const first = await fetchPage(1);
      const pages = [first];
      for (let next = 2; next <= first.pages; next += 4) {
        const batch = Array.from({ length: Math.min(4, first.pages - next + 1) }, (_, offset) => fetchPage(next + offset));
        pages.push(...await Promise.all(batch));
      }
      const products = pages.flatMap(page => page.products);
      if (pages.some(page => page.total !== first.total) || products.length !== first.total || new Set(products.map(product => product.id)).size !== first.total) throw new Error('Incomplete catalog');
      return products.filter(product => !(product.tags || []).includes('tbv-search-only') && product.handle !== 'adolf-hitler-historical-bust' && Number(product.id) !== 8089165889595);
    })();
    return indexPromise;
  }

  function card(product, position) {
    const article = document.createElement('article');
    article.className = 'tbv-directory__product';
    const link = document.createElement('a');
    link.href = product.url;
    const stage = document.createElement('div');
    stage.className = 'tbv-directory__product-image';
    if (product.image) {
      const image = document.createElement('img');
      image.src = product.image;
      image.alt = product.title;
      image.width = 540;
      image.height = 540;
      image.loading = position < 4 ? 'eager' : 'lazy';
      image.decoding = 'async';
      stage.append(image);
    }
    link.append(stage, text('h3', product.title), text('span', product.priceDisplay, 'tbv-directory__price'));
    article.append(link);
    return article;
  }

  function directoryGroup(group) {
    const section = document.createElement('section');
    section.className = 'tbv-directory__group';
    section.append(text('h3', group.heading));
    const list = document.createElement('div');
    list.className = 'tbv-directory__group-grid';
    group.items.forEach(item => {
      const link = document.createElement('a');
      link.className = 'tbv-directory__group-card';
      link.href = categoryUrl(item.slug);
      link.append(text('span', item.name), text('small', 'View busts', 'tbv-directory__group-count'));
      link.dataset.tbvCount = item.slug;
      list.append(link);
    });
    section.append(list);
    return section;
  }

  async function renderDirectory() {
    if (!directory) return;
    const slug = new URL(location.href).searchParams.get('category');
    const item = bySlug.get(slug);
    const home = directory.querySelector('[data-tbv-directory-home]');
    const results = directory.querySelector('[data-tbv-directory-results]');
    const status = directory.querySelector('[data-tbv-directory-status]');
    const grid = directory.querySelector('[data-tbv-directory-grid]');
    const more = directory.querySelector('[data-tbv-directory-more]');
    const title = directory.querySelector('[data-tbv-directory-title]');
    const description = directory.querySelector('[data-tbv-directory-description]');
    const groupsContainer = directory.querySelector('[data-tbv-directory-groups]');
    groupsContainer.replaceChildren(...groups.map(directoryGroup));
    if (item) {
      home.hidden = true;
      results.hidden = false;
      title.textContent = item.name;
      description.textContent = `A curated route through ${item.name.toLowerCase()}. A bust may appear in several groups.`;
      status.textContent = 'Loading busts...';
      document.title = `${item.name} | The Bust Vault`;
    }
    try {
      const products = await loadIndex();
      directory.querySelector('[data-tbv-catalog-total]').textContent = `${products.length.toLocaleString()} busts in the Vault`;
      groupsContainer.querySelectorAll('[data-tbv-count]').forEach(link => {
        const groupItem = bySlug.get(link.dataset.tbvCount);
        const count = products.filter(product => belongs(product, groupItem)).length;
        link.querySelector('small').textContent = `${count} ${count === 1 ? 'bust' : 'busts'}`;
      });
      if (!item) return;
      const matches = products.filter(product => belongs(product, item)).sort((a, b) => a.title.localeCompare(b.title));
      status.textContent = `${matches.length} ${matches.length === 1 ? 'bust' : 'busts'}`;
      let shown = 0;
      const append = () => {
        const next = matches.slice(shown, shown + 24);
        next.forEach((product, offset) => grid.append(card(product, shown + offset)));
        shown += next.length;
        more.hidden = shown >= matches.length;
      };
      more.addEventListener('click', append);
      append();
    } catch {
      if (item) {
        status.textContent = 'The catalog could not load right now.';
        const fallback = text('a', `Search ${item.name} instead`);
        fallback.href = `/search?type=product&q=${encodeURIComponent(item.name)}`;
        grid.append(fallback);
      } else {
        directory.querySelector('[data-tbv-catalog-total]').textContent = 'Browse the groups below';
      }
    }
  }

  installNavigation();
  const header = document.querySelector('#header-group');
  if (header) new MutationObserver(installNavigation).observe(header, { childList: true, subtree: true });
  renderDirectory();
})();
  } catch(e) { console.error(e); }
})();

})();
